import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { History } from 'history';

import { getGhaInfo } from '../../../store/actions/ghaAction';
import { receiveAwbs, receiveGhaAwbs, receiveGhaOrderAwbs, receiveOfflineOrderAwbs, awbsOfflineClearData } from '../../../store/actions/awbsAction';
import { receiveOfflineRfs } from '../../../store/actions/offlineRfsAction';
import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';
import { fetchFinish, fetchPending } from '../../../store/actions/fetchingAction';
import { updateWholeTruckCart } from '../../../store/actions/truckCartAction';

import { Button  } from '@material-ui/core';

import awbRemote from '../../../api/awbRemote';
import cartRemote from '../../../api/cartRemote';
import { baseUrl } from '../../../api/baseUrl';
import offlineRfsRemote from '../../../api/offlineRfsRemote';

import ManifestSetup from './ManifestSetup';
import ConfirmationDialog from '../../confirmation/ConfirmationDialog';
import ProcessBarContainer from '../../processBar/ProcessBarContainer';

import Awb from '../../../models/Awb';
import AwbPart, { AwbPartStatuses } from '../../../models/AwbPart';
import CartItem from '../../../models/CartItem';
import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import ManualEntryEdit from '../../../models/ManualEntryEdit';
import { UserRoleType } from '../../../models/User';
import User from '../../../models/User';
import OfflineRfs, { CurrentAwb, RfsAwbHistory, RfsAwbInfo } from '../../../models/OfflineRfs';
import rfsStyles from '../rfs.module.css';
import commonStyles from '../../common/common.module.css';
import TruckCart from '../../../models/TruckCart';
import TruckCartItem from '../../../models/TruckCartItem';

import { AWB_SCHEMA } from '../../../utils/airwayBill';
import { getAwbPartStatuses } from '../../../store/actions/awbPartStatusesAction';
import AttachmentsContainer from '../../attachments/AttachmentsContainer';
import validation from '../../../utils/validation';
import AddExportAWBModalContainer from '../../forwarderExport/addAWBModal/AddAWBModalContainer';
import ShipmentHistory from './ShipmentHistory';
import { AWB_BASE_INFO } from '../../../utils/offlineOrder';

interface AwbsProps {
  location?: any;
  user: User;
  userRole: UserRoleType;
  awbs: Array<Awb>;
  offlineRfs: OfflineRfs;
  ghaAwbs: Array<Awb>;
  cart: Array<CartItem>;
  port: string;
  gha_id: number;
  availableAwbPartStatuses: AwbPartStatuses;
  onReceiveAwbs: Function;
  onReceiveGhaAwbs: Function;
  onReceiveOfflineRfs: Function;
  onExistAirwayBill: Function;
  receiveSuccess: Function;
  receiveError: Function;
  fetchFinish: Function;
  fetchPending: Function;
  getAvailableAwbPartStatuses: Function;
  getGhaOrderAwbs: (orderNumber: string) => void;
  manualEntryEdit: ManualEntryEdit;
  truckCart: Array<TruckCartItem>;
  updateCart: (cart: TruckCart) => void;
  history: History;
  getGhaInfo: Function;
  getOfflineOrderAwbs: (orderNumber: string) => void;
  offlineOrderAwbs: Array<CurrentAwb>;
  clearOfflineOrderAwbsClearData: () => void;
  match: { isExact: boolean; params: { id: string }; path: string; url: string; };
};

const initialAwb = {
  id: 0,
  awb: '',
  org: '',
  dst: '',
  version: 0,
  pieces: '',
  weight: '',
  special: '',
  remarks: '',
  focused: false,
  wghFocused: false
}

interface ManifestSetupState {
  isModalOpen: boolean;
  requestId?: string;
  awbData: Awb;
  awbNumber: string;
  isAwbDeletionConfirmationOpen: boolean;
  code: string;
  number: string;
  didUpdates: number;
  isAttachmentsDialogOpen: boolean;
  isModalPoDOpen: boolean;
  type: string;
  currentAwb: CurrentAwb;
  offlineAwbs: Array<CurrentAwb>;
  isInitialAwbListed: boolean;
  manualOpen: boolean;
  manualEntry: boolean;
  exportModalOpen: boolean;
  editMode: boolean;
  shipmentHistoryModal: boolean;
  awbHistory: Array<RfsAwbHistory>;
  awbInfo: RfsAwbInfo;
  deleteAwbNumber: number;
  specialsOptions: string[];
};

class ManifestContainer extends Component <AwbsProps, ManifestSetupState> {

  state: ManifestSetupState = {
    isModalOpen: false,
    requestId: '',
    awbNumber: '',
    awbData: AWB_SCHEMA,
    isAwbDeletionConfirmationOpen: false,
    code: '',
    number: '',
    didUpdates: 0,
    isAttachmentsDialogOpen: false,
    isModalPoDOpen: false,
    type: 'export',
    currentAwb: initialAwb,
    offlineAwbs: [],
    isInitialAwbListed: false,
    manualOpen: false,
    manualEntry: false,
    exportModalOpen: false,
    editMode: false,
    shipmentHistoryModal: false,
    awbHistory: [],
    awbInfo: AWB_BASE_INFO,
    deleteAwbNumber: -1,
    specialsOptions: []
  };

  componentDidMount(): void {
    
    this.props.fetchPending();
    offlineRfsRemote.getSpecialsOptions().then((resp: ApiResponse<string[]>) => {
      this.props.fetchFinish();
      if (resp.result) {
        this.setState({ specialsOptions: resp.result });
      }
    }).catch(err => {
      this.props.fetchFinish();
      console.error(err);
    });

    if(this.props.match.params.id) {
      this.setState({ editMode: true });
    }
    this.props.onReceiveOfflineRfs();
    this.props.getGhaInfo(this.props.user.gha_id);
    this.props.clearOfflineOrderAwbsClearData();
  }

  componentDidUpdate(prevProps: AwbsProps): void {

    const cartItemsLength: number = this.props.cart.length;

    if(this.props.offlineRfs && this.props.offlineRfs.id && !this.state.isInitialAwbListed) {
      this.setState({ isInitialAwbListed: true });
      this.props.getOfflineOrderAwbs(this.props.offlineRfs.id.toString());
    }

    if(this.state.offlineAwbs.length === 0 && this.props.offlineOrderAwbs.length > 0) {
      this.setState({ offlineAwbs: this.props.offlineOrderAwbs });
    }

    if (cartItemsLength > 0 && this.state.didUpdates < 2) {
      this.setState({ didUpdates: this.state.didUpdates + 1 });
    }

    if (this.props.userRole === UserRoleType.FORWARDER) {
      const newProps: AwbsProps = this.props;

      if (prevProps.port !== newProps.port || prevProps.gha_id !== newProps.gha_id) {
        this.props.onReceiveAwbs(newProps.port, newProps.gha_id);
      };
    } else {
      const manualEntryEdit: ManualEntryEdit = this.props.manualEntryEdit;

      if (prevProps.ghaAwbs === this.props.ghaAwbs) { // ?????  CALLED 2 TIMES ! ???
        if (manualEntryEdit && manualEntryEdit.isEditMode) {
          this.props.getGhaOrderAwbs(manualEntryEdit.orderNumber);
        } else {
          this.props.onReceiveGhaAwbs(true);
        }
      }
    }
  };

  handleDelete = (id: number): void => {

    this.setState({ isAwbDeletionConfirmationOpen: true, deleteAwbNumber: id });
  };

  handleEdit = (awbData: Awb, opt: { edit: boolean, metadata: boolean }): void => {

      if (opt.edit) {

        awbRemote.editAwb(awbData, this.state.requestId).then((resp: ApiResponse<Awb>) => {

          const awb: Awb | undefined = resp.result;
          const error: ResponseError | undefined = resp.error;

          if (awb) {

            if (this.props.userRole === UserRoleType.GHA) {
              this.props.onReceiveGhaAwbs(false);
            }
          };

          if (error) {
            this.props.receiveError(error);
          };

          this.setState({ isModalOpen: false });
        });
      } else {
        this.setState({ isModalOpen: false });
      }
  };

  updateAwb = (): void => {

    if (this.state.awbInfo.code) {

      offlineRfsRemote.editRfsAwb(this.state.awbInfo.code, this.state.awbInfo.number, this.state.awbInfo).then((resp: ApiResponse<boolean>) => {

        const awb: boolean | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (awb) {
          const awbData: Awb = { ...this.state.awbData };
          awbData.pieces = this.state.awbInfo.pieces.toString();
          awbData.weight = this.state.awbInfo.weight.toString();
  
  
          this.setState({
            awbData,
            shipmentHistoryModal: false
          });
        };


        if (error) {
          this.props.receiveError(error);
        };
      });
    } else {
      this.setState({ isModalOpen: false });
    }
};

  closeConfirmationDialogs = (): void => {

    this.setState({ isAwbDeletionConfirmationOpen: false, code: '', number: '' });
  };

  deleteAwb = (): void => {

    const offlineAwbs = this.state.offlineAwbs;
    
    const orderId = this.props.match.params.id ? parseInt(this.props.match.params.id) : this.props.offlineRfs.id;

    if (!orderId) {
      const filteredAwbs: CurrentAwb[] = offlineAwbs.filter((item) => item.id !== this.state.deleteAwbNumber);
      this.setState({
        offlineAwbs: filteredAwbs
      });
      this.closeConfirmationDialogs();
      return;
    }

    offlineRfsRemote.deleteOfflineAwb(this.state.deleteAwbNumber, orderId).then((resp: ApiResponse<boolean>) => {

      const success: boolean | undefined = resp.success;
     const error: ResponseError | undefined = resp.error;

      if (success) {
        const filteredAwbs: CurrentAwb[] = offlineAwbs.filter((item) => item.id !== this.state.deleteAwbNumber);
        this.setState({
          offlineAwbs: filteredAwbs
        });
      };

      if (error) {
        this.props.receiveError(error);
      };

      this.closeConfirmationDialogs();
    });
  };

  checkAirwayBillIsInTheCart = (code: string, number: string, version: number): void => {

    const found: CartItem | undefined = this.findInCart(code, number);

    if (found) {

      const error: ResponseError = {
        errorCode: '',
        longDescription: 'Airwaybill is already in your cart!'
      };

      this.props.onExistAirwayBill(error);

    } else {

      offlineRfsRemote.addRfsExportAirwayBillToCart(code, number, version).then((resp: ApiResponse<TruckCart>) => {

        const cart: TruckCart | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (cart) {
          this.props.updateCart(cart);
            
          this.setState({
            requestId: '',
            offlineAwbs: [...this.state.offlineAwbs, this.state.currentAwb],
            currentAwb: initialAwb,
            awbNumber: ''
          }); 
        }

        if (error) {
            this.props.receiveError(error);
        };
      });
    }
  }

  findInCart = (number: string, code: string): CartItem | undefined => {

      return this.props.cart.find((cartElement: CartItem) => {
          return cartElement.code === code && cartElement.number === number;
      });
  };

  openAttachments = (awb: string): void => {

    const awbNumberArr: string[] = awb.split('-');
    this.setState({ isAttachmentsDialogOpen: true, code: awbNumberArr[0], number: awbNumberArr[1] });
  };

  closeAttachments = (): void => {

    this.setState({ isAttachmentsDialogOpen: false, code: '', number: '' });
  };

  checkTotalPcsAndWgt = (pieces: string, weight: string, parts: Array<AwbPart>): boolean => {

    const totalPcs: number = +(pieces);
    let sumPcs: number = parts.reduce((total, part) => {
        return (total + +(part.pieces));
    }, 0);

    let totalWeight: number = +(weight);
    let sumWgt: number = parts.reduce((total, part) => {
        return (total + +(part.weight));
    }, 0);

    if(totalWeight !== sumWgt || totalPcs !== sumPcs) {
      return true;
    };

    return false;
  };

  handleOpenPoD = (code: string, number: string): void => {

    this.setState({ isModalPoDOpen: true, code, number });
  };

  handleCloseModal = (modalType: string): void => {
    switch (modalType) {
      case 'import':
        this.setState({ isModalOpen: false });
        break;
      case 'pod':
        this.setState({ isModalPoDOpen: false, code: '', number: '' });
        break;
      case 'history':
        this.setState({ shipmentHistoryModal: false });
        break; 
      default:
        break;
    }

  }

  handleClick = (name: string, value: boolean): void => {

    const currentAwb: CurrentAwb = { ...this.state.currentAwb };
    switch(name) {
      case 'pieces': 
        currentAwb.focused = value;
        this.setState({ currentAwb: currentAwb });
      break;

      case 'weight': 
        currentAwb.wghFocused = value;
        this.setState({ currentAwb: currentAwb });
      break;

      default: break;
    }
    
  }

  searchAwb = (event: any): void => {
    if (event.key === 'Enter' || event.key === undefined) {
      if (validation.validateAWB(this.state.awbNumber)) {
        const awbCode = this.state.awbNumber.split('-')[0];
        const awbNumber = this.state.awbNumber.split('-')[1];
  
        this.props.fetchPending();
        const isExport: boolean = this.state.type === 'export';

        const handleSuccess = (awbData: Awb, requestId: string) => {
          const currentAwb: CurrentAwb = { ...this.state.currentAwb };
          currentAwb.awb = awbData.code+'-'+awbData.number;
          currentAwb.id = awbData.id;
          currentAwb.org = awbData.origin;
          currentAwb.dst = awbData.destination;
          currentAwb.pieces = awbData.pieces.toString();
          currentAwb.weight = awbData.weight;
          currentAwb.version = awbData.version;
  
          const awbInfo: RfsAwbInfo = { ...this.state.awbInfo };
          awbInfo.code = awbData.code;
          awbInfo.number = awbData.number;
          awbInfo.org = awbData.origin;
          awbInfo.dst = awbData.destination;
          awbInfo.version = awbData.version;
          awbInfo.pieces = Number(awbData.pieces);
          awbInfo.weight = Number(awbData.weight);
  
          this.setState({
            awbData: awbData,
            requestId: requestId,
            currentAwb: currentAwb,
            awbInfo
          });
          offlineRfsRemote.getRfsAwbHistory(awbCode, awbNumber).then((resp: ApiResponse<RfsAwbHistory[]>) => {
            const history: RfsAwbHistory[] | undefined = resp.result;
            const error: ResponseError | undefined = resp.error;
    
            if (history) {
              this.setState({ awbHistory: history });
            }
    
            if (error) {
              this.props.receiveError(error);
            };
          });
  
          this.props.fetchFinish();
        };

        const handleError = (err: any) => {
          this.props.fetchFinish();
          if (err.errorCode === '#couldntExtractAWBInfo' || err.errorCode === '#airwayCodeNotFound') {
            
            this.setState({
              awbData: AWB_SCHEMA,
              manualOpen: true,
              requestId: ''
            });
          } else {
            this.props.receiveError(err);
          }
        };

        awbRemote.getAwb(this.state.awbNumber, isExport, undefined, true).then((resp: ApiResponse<Awb>) => {
          if (resp.result) {
            handleSuccess(resp.result, '');
          } else {
             awbRemote.extractAwb(this.state.awbNumber, this.state.type).then((resp: { awbData: Awb, requestId: string }) => {
                handleSuccess(resp.awbData, resp.requestId);
             }, (err) => { 
                handleError(err);
             });
          }
        }, () => {
           awbRemote.extractAwb(this.state.awbNumber, this.state.type).then((resp: { awbData: Awb, requestId: string }) => {
              handleSuccess(resp.awbData, resp.requestId);
           }, (err) => { 
              handleError(err);
           });
        });
      } else {
        let errObj: ResponseError = {
          errorCode: '',
          longDescription: 'The entered value should contain a code (3 digits) and a number (8 digits) separated by a dash (-)!'
        }
        this.props.receiveError(errObj);
      }
    }
   
  }
  
  handleChange = (name: string, event: any): void => {

    const currentAwb: CurrentAwb = { ...this.state.currentAwb };

    switch(name) {
      case 'awbNumber': 
        let value: string = event.target.value;

        if (value.length === 3 && this.state.awbNumber.length === 2) {
          value = value + '-';
        }

        if (value.length === 11) {
          if (value.indexOf('-') < 0) {
            value = value.slice(0 , 3) + '-' + value.slice(3);
          }
        }

        if (value.split('-').length > 2) {
          return;
        }

        this.setState({ awbNumber: value }); 
      break;
      case 'org':
        currentAwb.org =  event.target.value;
        this.setState ({ currentAwb });
      break;
      case 'dst':
        currentAwb.dst =  event.target.value;
        this.setState ({ currentAwb });
      break;
      case 'pieces':
        currentAwb.pieces =  event.target.value;
        this.setState ({ currentAwb });
      break;
      case 'weight':
        currentAwb.weight =  event.target.value;
        this.setState ({ currentAwb });
      break;
      case 'special':
        currentAwb.special =  event.target.value;
        this.setState ({ currentAwb });
      break;
      case 'remarks':
        currentAwb.remarks =  event.target.value;
        this.setState ({ currentAwb });
      break;

      default: break;
    }
  }

  handleChangeAwb = (name: string, event: any): void => {

    const awbInfo: RfsAwbInfo = { ...this.state.awbInfo };

    switch(name) {
      case 'org':
        awbInfo.org =  event.target.value;
        this.setState ({ awbInfo });
      break;
      case 'dst':
        awbInfo.dst =  event.target.value;
        this.setState ({ awbInfo });
      break;
      case 'pieces':
        awbInfo.pieces =  event.target.value;
        this.setState ({ awbInfo });
      break;
      case 'weight':
        awbInfo.weight =  event.target.value;
        this.setState ({ awbInfo });
      break;

      default: break;
    }
  }

  handleSave = (awbData: Awb, opts: { edit: boolean, metadata: boolean}): void => {

    const isExport: boolean = this.state.type === 'export';

    awbRemote.addAwbList(awbData, opts.edit, isExport, this.state.requestId, undefined, awbData.version).then((resp: ApiResponse<Awb>) => {

      const awb: Awb | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (awb) {
        this.checkAirwayBillIsInTheCart(awb.code, awb.number, awb.version)
  
        if(this.props.userRole === UserRoleType.GHA) {
          const isExport: boolean = !!(this.state.type === 'export');
          this.props.onReceiveGhaAwbs(isExport);
        }
        const currentAwb: CurrentAwb = { ...this.state.currentAwb };
        currentAwb.awb =  awb.code + '-' + awb.number;
        currentAwb.id =  awb.id;
        currentAwb.org =  awb.origin;
        currentAwb.dst =  awb.destination;
        currentAwb.version = awb.version;
        currentAwb.pieces =  awb.pieces.toString();
        currentAwb.weight =  awb.weight;

        this.setState({
          awbData: awb,
          currentAwb: currentAwb,
          exportModalOpen: false,
          requestId: ''
        });    
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  handleAddAwb = (awbData: Awb, manualEntry: boolean, opts: { edit: boolean, metadata: boolean}): void => {

    const isExport: boolean = this.state.type === 'export';
    if(!manualEntry) {
      awbRemote.addAwbList(awbData, opts.edit, isExport, this.state.requestId, true, awbData.version).then((resp: ApiResponse<Awb>) => {

        const awb: Awb | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
  
        if (awb) {
          this.checkAirwayBillIsInTheCart(awb.code, awb.number, awb.version)
  
          if(this.props.userRole === UserRoleType.GHA) {
            const isExport: boolean = !!(this.state.type === 'export');
            this.props.onReceiveGhaAwbs(isExport);
          }   
        }
  
        if (error) {
          this.props.receiveError(error);
        }
      });
    } else {
      this.setState({
        requestId: '',
        offlineAwbs: [...this.state.offlineAwbs, this.state.currentAwb],
        currentAwb: initialAwb,
        awbNumber: '',
        manualEntry: false
      }); 
    }

  }

  addAwb = (): void => {

    const opt = { edit: true, metadata: false }
    let awb: Awb = { ...this.state.awbData };
    awb.export_metadata.shipperProfile = 'Unknown';

    this.setState({ awbData : awb });
    this.handleAddAwb(this.state.awbData, this.state.manualEntry, opt);
  }

  handleManualYes = (): void => {

    const awb = this.state.awbNumber.split('-');

    this.setState({
      awbData: {
          ...this.state.awbData,
          code: awb[0],
          number: awb[1]
      },
      exportModalOpen: this.state.type === 'export',
      manualOpen: false,
      manualEntry: true,
      requestId: ''
    });
  }

  setContainerState = (data: any): void => {

    const { offlineAwbs } = data;
    if (offlineAwbs) {
      this.setState({ offlineAwbs: offlineAwbs });
    }
  }

  isDisabled = (): boolean => {

    if (this.state.awbNumber !== '') {
      return false;
    };
    return true;
  }

  openModal = (): void => {
    this.setState({ shipmentHistoryModal: true });
  }

  handleClose = (modalType: string): void => {
    
    this.setState({ exportModalOpen: false, requestId: '' });
  }

  submitOfflineOrder = (): void => {

    const offlineRfsAwb:Array<CurrentAwb> = { ...this.state.offlineAwbs };

    if (Object.keys(offlineRfsAwb).length == 0) {
      this.props.history.push('/manage-rfs');
    } else {
      offlineRfsRemote.saveRfsAwb(offlineRfsAwb, this.state.editMode).then((resp: ApiResponse<TruckCart>) => {

        const success: TruckCart | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (success) {
          this.props.history.push('/manage-rfs');
        }

        if (error) {
          this.props.receiveError(error);
        }
      });
    }
  };

  printAwbInfoClicked = (awb: string, version: number) => {
    
    const awbNumberArr: string[] = awb.split('-');
    this.setState({ code: awbNumberArr[0], number: awbNumberArr[1] });

    let url: string = `${baseUrl}pickup_order/awb/${awbNumberArr[0]}/${awbNumberArr[1]}/${version}/file`;
  
    window.open(url);
  }

  render() {

    return (
      <Fragment>
        <div className= { commonStyles.headerDummyDiv }> </div>
        <ManifestSetup
          handleClick={ this.handleClick }
          offlineRfs={ this.props.offlineRfs }
          awbValue={ this.state.awbNumber }
          isDisabled={ this.isDisabled }
          handleChange={ this.handleChange }
          searchAwb={ this.searchAwb }
          awb={ this.state.awbData }
          currentAwb={ this.state.currentAwb }
          addAwb={ this.addAwb }
          offlineAwbs={ this.state.offlineAwbs }
          specialsOptions={ this.state.specialsOptions }
          openAttachments={ this.openAttachments }
          deleteAwb={ this.handleDelete }
          setState={ this.setContainerState }
          printAwbInfoClicked={ this.printAwbInfoClicked }
          manualEntry={ this.state.manualEntry }
          openShipmentHistory={ this.openModal }
        />

        { this.state.isAttachmentsDialogOpen && 
          <AttachmentsContainer
            code = { this.state.code }
            number = { this.state.number }
            process = { 'export' }
            closeAttachments = { this.closeAttachments }
            refreshAwbs={ true }
          />
        }

        { this.state.isAwbDeletionConfirmationOpen && 
          <ConfirmationDialog
            open={ this.state.isAwbDeletionConfirmationOpen }
            close={ () => { this.setState({ isAwbDeletionConfirmationOpen: false }) } }
            title='Delete Confirmation'
            text='Are you sure you want to delete this airwaybill?'
            textConfirm='delete'
            confirm={ this.deleteAwb } 
            showCloseIcon={ true }
          />
        }

        { this.state.manualOpen &&
          <ConfirmationDialog
            open={ this.state.manualOpen }
            title='This AWB cannot be found!'
            text='Do you want to add it manually?'
            close={() => { this.setState({ manualOpen: false }) }}
            confirm={ this.handleManualYes }
            textConfirm='yes'
            showCloseIcon={ true }
          /> 
        }

        { this.state.exportModalOpen &&
          <AddExportAWBModalContainer 
            modalOpen={ this.state.exportModalOpen }
            awb={ this.state.awbData }
            handleSave={ this.handleSave }
            handleCloseModal={ this.handleClose }
            awbActionOfUpdateButton={ 'add' }
            edited={ true }
            manualEntry={ this.state.manualEntry }
            userRole={ this.props.userRole }
          />
        } 
        <ShipmentHistory 
          modalOpen={ this.state.shipmentHistoryModal }
          handleChange={ this.handleChangeAwb }
          handleClose={ this.handleCloseModal }
          awbHistory={ this.state.awbHistory }
          awbInfo={ this.state.awbInfo }
          handleSave={ this.updateAwb }
        />

        { this.props.userRole === UserRoleType.GHA &&
          <div className={ rfsStyles.btnWrapper}>
            <Button onClick={ this.submitOfflineOrder } color="primary" variant="contained" >Save & Exit</Button>
          </div>
        }

      </Fragment>
    );
  };
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    awbs: state.awbs.awbs,
    ghaAwbs: state.awbsGha,
    cart: state.cart.items,
    port: state.destinationPort,
    gha_id: state.destinationGhaId,
    availableAwbPartStatuses: state.awbPartStatuses,
    manualEntryEdit: state.manualEntryEdit,
    offlineRfs: state.offlineRfs.offlineRfs,
    truckCart: state.truckCart.cart,
    offlineOrderAwbs: state.awbsOffline
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    updateCart: (cart: TruckCart) => dispatch(updateWholeTruckCart(cart)),
    onReceiveAwbs: (port: string, gha: number) => dispatch(receiveAwbs(port, gha)),
    onReceiveGhaAwbs: (isExport: boolean) => dispatch(receiveGhaAwbs(isExport)),
    onReceiveOfflineRfs: () => dispatch(receiveOfflineRfs()),
    getAvailableAwbPartStatuses: () => dispatch(getAwbPartStatuses()),
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess: (msg: string) => dispatch(receiveSuccess(msg)),
    onExistAirwayBill: (error: ResponseError) => dispatch(receiveError(error)),
    fetchFinish: () => dispatch(fetchFinish()),
    fetchPending: () => dispatch(fetchPending()),
    getGhaOrderAwbs: (orderNumber: string) => dispatch(receiveGhaOrderAwbs(orderNumber)),
    getGhaInfo: (ghaId: number) => dispatch(getGhaInfo(ghaId)),
    getOfflineOrderAwbs: (orderNumber: string) => dispatch(receiveOfflineOrderAwbs(orderNumber)),
    clearOfflineOrderAwbsClearData: () => dispatch(awbsOfflineClearData())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManifestContainer);
